import { rHandler } from '@/plugins/RHandler';
import { apiService } from '@/services/APIService';
import { objectsRHandler, DEFAULT_PARAMS } from '@/utils/objectsRHandler';
import Expert from '../list/expert';

const API_PATH = 'expert';
const EXPERTS_PATH = `${API_PATH}s`;
const INVITES_PATH = 'expert-invites';

const getInviteValue = (payload = {}) =>
  payload?.invite
  || payload?.invite_code
  || payload?.code
  || null;

export const ExpertManager = {
  objects: objectsRHandler(EXPERTS_PATH, Expert),

  get requests() {
    return {
      invite: ({ params } = DEFAULT_PARAMS) => {
        const expertId = params?.expert_id || params?.user_ids?.[0] || params?.expert_ids?.[0];

        return rHandler(
          apiService.post(`${EXPERTS_PATH}/${expertId}/invite`, {}),
          (response) => ({ response }),
          (error) => ({ error }),
        );
      },
      cancelInvite: () => rHandler(
        Promise.reject(new Error('Бэкенд больше не поддерживает отмену приглашения или отвязку пользователя от эксперта')),
        (response) => ({ response }),
        (error) => ({ error }),
      ),
    };
  },

  invite: ({ data } = DEFAULT_PARAMS) => rHandler(
    apiService.post(`${INVITES_PATH}/accept`, {
      invite: getInviteValue(data),
    }),
    (response) => ({ response }),
    (error) => ({ error }),
  ),

  getInviteData: ({ params } = DEFAULT_PARAMS) => rHandler(
    apiService.post(`${INVITES_PATH}/show-info`, {
      invite: getInviteValue(params),
    }, { params }),
    (response) => ({
      response,
      item: response?.data?.data,
    }),
    (error) => ({ error }),
  ),

  getInvite: ({ args } = DEFAULT_PARAMS) => {
    const [expertId] = args;

    return rHandler(
      apiService.get(`${EXPERTS_PATH}/${expertId}/invite`),
      (response) => ({ response }),
      (error) => ({ error }),
    );
  },

  makeInvite: ({ args } = DEFAULT_PARAMS) => {
    const [expertId] = args;

    return rHandler(
      apiService.post(`${EXPERTS_PATH}/${expertId}/invite`, {}),
      (response) => ({ response }),
      (error) => ({ error }),
    );
  },

  makeActive: ({ args } = DEFAULT_PARAMS) => {
    const [expertId] = args;

    return rHandler(
      apiService.post(`${EXPERTS_PATH}/${expertId}/make-active`, {}),
      (response) => ({ response }),
      (error) => ({ error }),
    );
  },

  makeDisable: ({ args } = DEFAULT_PARAMS) => {
    const [expertId] = args;

    return rHandler(
      apiService.post(`${EXPERTS_PATH}/${expertId}/make-disable`, {}),
      (response) => ({ response }),
      (error) => ({ error }),
    );
  },

  attachToEvent: ({ args, data } = DEFAULT_PARAMS) => {
    const [expertId] = args;

    return rHandler(
      apiService.post(`${EXPERTS_PATH}/${expertId}/attach`, data),
      (response) => ({ response }),
      (error) => ({ error }),
    );
  },

  detachFromEvent: ({ args, data } = DEFAULT_PARAMS) => {
    const [expertId] = args;

    return rHandler(
      apiService.post(`${EXPERTS_PATH}/${expertId}/detach`, data),
      (response) => ({ response }),
      (error) => ({ error }),
    );
  },
};
